// utils/extractDomain.js
import isString from "lodash/isString";
import split from "lodash/split";

/**
 * Extracts the “registrable” domain (the part before the TLD and after any subdomain)
 * from the first email address found in the input string.
 *
 * Examples:
 *   extractDomain("joliva@cliffcomortgage.com")         // → "cliffcomortgage"
 *   extractDomain("foo@sub.domain.co.uk")              // → "domain"
 *   extractDomain("reach me at user@example")          // → null
 *   extractDomain(null)                                // → null
 *
 * @param {*} input – any value that may contain an email
 * @returns {string|null} – the domain name, or null if none found
 */
export function extractDomain(input) {
  if (!isString(input)) return null;

  // Find an email in the string
  const emailMatch = input.match(
    /\b[A-Za-z0-9._%+-]+@([A-Za-z0-9.-]+\.[A-Za-z]{2,})\b/
  );
  if (!emailMatch) return null;

  // emailMatch[1] is the full host (e.g. "sub.domain.com")
  const host = emailMatch[1];
  // Split into labels
  const labels = split(host, ".");
  if (labels.length < 2) return null;

  // If there are more than 2 labels, the registrable domain is the second-to-last
  // Otherwise it's the first label (e.g. ["example","com"] → "example")
  return labels[labels.length > 2 ? labels.length - 2 : 0];
}
